import { TableCell, TableRow } from '@material-ui/core'
import dateFormat from 'dateformat'
import { TFunction } from 'i18next'
import AccountGroupIcon from 'mdi-react/AccountGroupIcon'
import { Fragment, FC } from 'react'
import {
  SelectApartment,
  RemoveApartment,
  Navigate,
  UpdateStatus,
  UpdateApartmentCode
} from '../../../actions/types'
import { MuiClasses } from '../../../types'
import { Apartment } from '../../../types/apartments'
import { Application } from '../../../types/applications'
import { ReservableShowings } from '../../../types/showings'

import {
  IndexedUsersState,
  EmptyReservableShowings
} from '../../../types/states'
import {
  getApartmentOwnerEmail,
  getApartmentOwnerPhone
} from '../../../utils/apartments'

import { getApplicationsAmounts } from '../../Applications/values/handleApplicationsData'
import { ApartmentsShowingProps } from '../Apartments'
import ApartmentsTableRowCollapse from './ApartmentsTableRowCollapse'
import ApplicationsCell from './ApplicationsCell'
import StatusChipsCell from './StatusChipsCell'
export interface ApartmentRowProps {
  classes: MuiClasses
  apartment: Apartment
  apartmentApplications: Application[]
  isSelected: boolean
  showingsProps: ApartmentsShowingProps
  t: TFunction
  deselectApartment: () => void
  selectApartment: SelectApartment
  removeApartment: RemoveApartment
  listUsersAction: () => void
  navigate: Navigate
  updateStatus: UpdateStatus
  updateApartmentCode: UpdateApartmentCode
  colSpan: number
  users: IndexedUsersState
}

const ApartmentRow: FC<ApartmentRowProps> = ({
  classes,
  apartment,
  apartmentApplications,
  isSelected,
  showingsProps,
  t,
  deselectApartment,
  selectApartment,
  listUsersAction,
  removeApartment,
  navigate,
  updateStatus,
  updateApartmentCode,
  colSpan,
  users
}) => {
  const {
    userId,
    apartmentId,
    createdAt,
    updatedAt,
    applicationsViewedAt,
    confirmation,
    information,
    code,
    status
  } = apartment
  const apartmentApplicationAmounts = getApplicationsAmounts(
    apartmentApplications || []
  )
  const address = information
    ? `${information.address}, ${information.postalArea}`
    : undefined
  const showingsInterfaces = showingsProps.showingsInterfaces
  const reservableShowings: ReservableShowings = showingsInterfaces
    ? showingsInterfaces[apartmentId]?.reservableShowings ||
      EmptyReservableShowings
    : EmptyReservableShowings

  const apartmentUserEmail = getApartmentOwnerEmail(apartment, users)
  const apartmentUserPhone = getApartmentOwnerPhone(apartment, users)
  return (
    <Fragment key={apartmentId}>
      <TableRow
        hover
        className={classes.normalRow}
        onClick={() =>
          isSelected
            ? deselectApartment()
            : (listUsersAction(), selectApartment(apartmentId))
        }
        tabIndex={-1}
        key={apartmentId}
        selected={isSelected}
      >
        <TableCell>{t(`adminApartments.statuses.${status}`)}</TableCell>
        <StatusChipsCell
          apartment={apartment}
          applicationAmounts={apartmentApplicationAmounts}
          reservableShowings={reservableShowings}
          t={t}
          apartmentUser={users[apartment.userId]}
        />
        <TableCell>{address}</TableCell>

        <ApplicationsCell {...apartmentApplicationAmounts} />
        <TableCell>{confirmation?.price}</TableCell>
        <TableCell>{apartmentUserEmail}</TableCell>
        <TableCell style={{ textAlign: 'center' }}>
          {' '}
          <a
            href='#'
            style={{ color: 'inherit', textDecoration: 'none' }}
            onClick={() => {
              navigate(
                `/users/${userId}/apartments/${apartmentId}/applications`
              )
            }}
            className='mdi mdi-account-group'
          >
            <AccountGroupIcon />
          </a>
        </TableCell>

        <TableCell>
          <a
            style={{ color: 'inherit', textDecoration: 'none' }}
            href={`tel:+${apartmentUserPhone}`}
          >
            +{apartmentUserPhone}
          </a>
        </TableCell>
        <TableCell>{code}</TableCell>
        <TableCell>{dateFormat(createdAt, 'dd.mm.yyyy HH:MM')}</TableCell>
        <TableCell>{dateFormat(updatedAt, 'dd.mm.yyyy HH:MM')}</TableCell>
        <TableCell>
          {applicationsViewedAt
            ? dateFormat(applicationsViewedAt, 'dd.mm.yyyy HH:MM')
            : t('apartments.table.values.unknown')}
        </TableCell>
      </TableRow>
      {isSelected && (
        <TableRow className={classes.selectedRow}>
          <TableCell colSpan={colSpan}>
            <ApartmentsTableRowCollapse
              apartment={apartment}
              removeApartment={removeApartment}
              navigate={navigate}
              apartmentApplications={apartmentApplications}
              t={t}
              updateStatus={updateStatus}
              updateApartmentCode={updateApartmentCode}
            />
          </TableCell>
        </TableRow>
      )}
    </Fragment>
  )
}

export default ApartmentRow
